var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _path12, _path13, _path14, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _polygon19, _line, _path15, _path16, _path17, _path18, _path19, _polygon20, _path20, _polygon21, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon22, _polygon23, _path33, _path34, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _line2, _line3, _polygon32, _polygon33, _polygon34, _polygon35, _path35, _path36, _path37, _path38, _path39, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _rect, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _path40, _path41, _path42, _path43, _path44, _path45, _line4, _path46, _path47, _path48, _path49, _path50, _polygon50, _polygon51, _path51, _path52, _path53, _path54, _polygon52, _polygon53, _path55, _path56, _line5, _path57, _path58, _path59, _path60, _line6, _line7, _path61, _path62, _polygon54, _polygon55, _polygon56, _polygon57, _polyline, _polygon58, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _line8, _path77, _path78, _polygon59, _polygon60, _path79, _path80, _polygon61, _polygon62, _line9, _line10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 784.9 459",
    style: {
      enableBackground: "new 0 0 784.9 459"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3F3A3C;}\r\n\t.st1{fill:#68C7C4;}\r\n\t.st2{fill:#F6921E;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{fill:#EE4036;}\r\n\t.st5{fill:#FAAF40;}\r\n\t.st6{fill:#89C540;}\r\n\t.st7{fill:#29B473;}\r\n\t.st8{fill:#009F8D;}\r\n\t.st9{fill:#27AEBD;}\r\n\t.st10{fill:#2799C6;}\r\n\t.st11{fill:#B4D234;}\r\n\t.st12{fill:#3EBA93;}\r\n\t.st13{fill:url(#SVGID_00000036957020559162829190000000462386669304429992_);}\r\n\t.st14{fill:#4D61AB;}\r\n\t.st15{fill:#83D2E7;}\r\n\t.st16{fill:#BF4699;}\r\n\t.st17{fill:#F26F3F;}\r\n\t.st18{fill:#454A9E;}\r\n\t.st19{fill:url(#SVGID_00000031900494808892135300000001465309153223834525_);}\r\n\t.st20{fill:url(#SVGID_00000114051069403898027230000010642411652988134841_);}\r\n\t.st21{fill:url(#SVGID_00000031889032187322998830000001431892766252425616_);}\r\n\t.st22{fill:none;}\r\n\t.st23{fill:url(#SVGID_00000150809210662572212610000017701727626558086552_);}\r\n\t.st24{fill:url(#SVGID_00000102536416038126616240000006134793903649449147_);}\r\n\t.st25{fill:url(#SVGID_00000183933642393812315850000011762757099888510649_);}\r\n\t.st26{fill:url(#SVGID_00000116220356327342976540000001739793728958080698_);}\r\n\t.st27{fill:url(#SVGID_00000178924805856433086720000003629696134068316594_);}\r\n\t.st28{fill:#B3E1EC;}\r\n\t.st29{fill:#00ADEE;}\r\n\t.st30{fill:url(#SVGID_00000147203007230728996130000005107237798027683726_);}\r\n\t.st31{fill:url(#SVGID_00000004531589164875015160000010926954177628333216_);}\r\n\t.st32{fill:url(#SVGID_00000120549158938865023800000007094528136456003739_);}\r\n\t.st33{fill:url(#SVGID_00000096750175472993465680000004219696989382825138_);}\r\n\t.st34{fill:#69B8E2;}\r\n\t.st35{fill:url(#SVGID_00000035514660452055181300000011863198319006274751_);}\r\n\t.st36{fill:#3D9AC9;}\r\n\t.st37{fill:#319BC1;}\r\n\t.st38{fill:#60B7DF;}\r\n\t.st39{fill:url(#SVGID_00000129919251633401061100000012068361216445144997_);}\r\n\t.st40{fill:#68B8E1;}\r\n\t.st41{fill:url(#SVGID_00000016782063651224269940000010066920117934288805_);}\r\n\t.st42{fill:url(#SVGID_00000002386378685903065240000015577676964688197529_);}\r\n\t.st43{fill:#4BA3CE;}\r\n\t.st44{fill:url(#SVGID_00000011749111208298362100000014001395281404984510_);}\r\n\t.st45{fill:url(#SVGID_00000125578968866010597490000007911145591946799535_);}\r\n\t.st46{fill:url(#SVGID_00000083788046690475060260000016568574072515453847_);}\r\n\t.st47{fill:#A2D6E4;}\r\n\t.st48{fill:#DDE5EC;}\r\n\t.st49{fill:#ADD0E6;}\r\n\t.st50{fill:#8FCDE9;}\r\n\t.st51{fill:#ADE0F3;}\r\n\t.st52{fill:#C5DDE4;}\r\n\t.st53{fill:#AADEEF;}\r\n\t.st54{fill:#ADDCF0;}\r\n\t.st55{fill:#93C9E2;}\r\n\t.st56{fill:#A6CFE1;}\r\n\t.st57{fill:#7EB3D0;}\r\n\t.st58{fill:#4EA2D0;}\r\n\t.st59{fill:#90CAE7;}\r\n\t.st60{fill:#65B9E2;}\r\n\t.st61{fill:url(#SVGID_00000046307770406877640830000010459009025919017107_);}\r\n\t.st62{fill:url(#SVGID_00000105412447544531462960000016082416324114129594_);}\r\n\t.st63{fill:url(#SVGID_00000164514791657724626330000017922721329244199830_);}\r\n\t.st64{fill:#6BB8DD;}\r\n\t.st65{fill:#3391BE;}\r\n\t.st66{fill:url(#SVGID_00000006668635119049614810000006864198234879768722_);}\r\n\t.st67{fill:#73BDE0;}\r\n\t.st68{fill:#EEEDED;}\r\n\t.st69{fill:url(#SVGID_00000089558935964288730540000002726410336923599546_);}\r\n\t.st70{fill:url(#SVGID_00000142883011754044150030000017195163664039505281_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.7,239.7c-7.7,0-12.3-5.9-12.3-14.1s4.6-14.1,12.3-14.1c3.9-0.1,7.5,1.9,9.7,5.1l8.2-6.8 c-4.2-5.6-10.9-8.9-17.9-8.9c-12.7,0-22.8,10.1-22.8,24.9c0,14.5,9.9,24.6,22.8,24.6c7.1,0.1,13.7-3.2,17.9-8.9l-8.2-6.5 C178.1,238,174.5,239.8,170.7,239.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.9,201.9l-7.3,17.5h-0.2l-7.4-17.5h-12.8l15.1,30.6v16.6h10.5v-16.6l15.1-30.7H219.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.7,225.1L271.7,225.1c3.4-1.7,4.1-6.4,4.1-9.1c0-8.7-6-14.2-14.5-14.2h-22.5v10.3h21.8c3.1,0,4.8,2,4.8,4.5 s-1.7,4.5-4.8,4.5h-21.8v8.9h22.7c3.3,0,4.7,1.8,4.7,4.5s-1.5,4.5-4.7,4.5h-22.7v10.1h23.5c8.5,0,14.5-5.3,14.5-13.9 C276.7,230.6,274.8,226.3,271.7,225.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.1,220.5L294.1,220.5l-10.4-0.1v9.5h10.4v0h19.4v-9.3L294.1,220.5z M294.1,238.9L294.1,238.9l-10.4-0.1l0,0 v10.3h32.5v-10.2H294.1z M283.7,201.9v10.3h10.4v-0.1h22v-10.2H283.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.6,218.7c0-11-6-16.8-15.5-16.8h-20.5v10.4c0.2-0.1,0.5-0.1,0.7-0.1h9.7v-0.1h9.3c3.5,0,5.8,2.4,5.8,6.6 c0,4.8-2.3,6.8-5.8,6.8h-19c-0.2,0-0.5,0-0.7-0.1v23.8H335v-13.4h7.2l6.6,13.5h11.8l-7.8-14.9C357.9,231.9,360.6,226.8,360.6,218.7z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.3,239.7c-7.7,0-12.3-5.9-12.3-14.1s4.6-14.1,12.3-14.1c3.9-0.1,7.6,1.8,9.7,5.1l8.2-6.8 c-4.2-5.6-10.9-8.9-17.9-8.9c-12.7,0-22.8,10.1-22.8,24.8c0,14.5,9.9,24.6,22.8,24.6c7.1,0.1,13.7-3.2,17.9-8.9l-8.2-6.5 C396.8,238,393.2,239.8,389.3,239.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450.3,218.7c0-11-6.1-16.8-15.5-16.8h-20.5v10.2H434c3.5,0,5.8,2.4,5.8,6.6c0,4.8-2.3,6.8-5.8,6.8h-9.3l0,0 c0,0-0.1,0-0.1,0h-10.3v23.7h10.4v-13.4h7.2l6.6,13.5h11.8l-7.8-14.9C447.5,231.9,450.3,226.8,450.3,218.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.7,201.9h-11.6l-16.2,47.3h11.6l2.6-8.5h15.4l2.7,8.5h11.6L481.7,201.9z M471.2,231.1l4.6-14.4h0.1 l4.6,14.4L471.2,231.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502,201.9v10.3h32.5v-10.3H502z M512.4,220.5L512.4,220.5l-10.4-0.1v28.7h10.4v-19.3h19.4v-9.3H512.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.1,201.9v10.2h12.4v37.1h10.4v-37.1h12.5v-10.2H538.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M605.7,201.9l-1.7,2.2l-18.2,24.5l-0.1,0.2l-7.3,10.3l-0.1,10.1h5.5l16.3-22.8l10.8-15.2l0.1-9.2H605.7z  M603.3,238.9l-7.3,10.2h14.9v-10.2H603.3z M578.3,201.9v10.2h7.3l7.6-10.2H578.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "261,359.6 258.2,355.7 313.8,309.4 316.6,313.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "307.4,417.6 259.8,365.6 263,362.1 310.7,414.2 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "139.9,120.5 69.1,100.7 70.2,96 141,115.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "179.4,28.1 179.3,23.2 246.5,21.9 246.6,26.8 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "108.7,395.8 78.6,367.6 81.6,363.8 111.7,392.1 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "138.3,118.9 122.5,72.4 126.8,70.7 142.6,117.3 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "141,119.2 136.9,117 177.3,26.2 181.4,28.3 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "97.8,168.5 94.5,165.2 137.3,116.4 140.6,119.8 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.2,218.4 34.4,163.1 38,160.2 75.8,215.5 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40.9,297.5 37.1,294.7 71.3,241.5 75.1,244.3 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "83.7,354.9 82.6,350.1 135.6,336.1 136.7,340.8 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "90.7,277.9 83.6,246 88.1,244.9 95.2,276.7 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "250.4,429.3 245.9,428.8 250.5,370.6 255,371 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "191.3,366.5 191.1,361.6 255.2,359 255.4,363.9 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "357.3,375.5 260.3,363.4 260.8,358.5 357.8,370.6 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "270,86.8 266.9,83.2 296.5,53.4 299.6,57 "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "198.6,96.1 196.8,91.6 294,47.7 295.7,52.2 "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "349.4,77.1 321.3,55.5 324,51.5 352.1,73.1 "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 265.4,
    cy: 90.5,
    rx: 13,
    ry: 13.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.7872,
    y1: 375.6843,
    x2: 207.2672,
    y2: 375.6843,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFA222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0592D"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 194,
    cy: 93.7,
    rx: 13.2,
    ry: 14
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 246.6,
    cy: 23.6,
    rx: 13.9,
    ry: 14.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 179.4,
    cy: 27.3,
    rx: 11.2,
    ry: 11.9
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 139,
    cy: 118.1,
    rx: 12.5,
    ry: 13.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 96.1,
    cy: 166.9,
    rx: 11.6,
    ry: 12.4
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 69.6,
    cy: 99.6,
    rx: 12.1,
    ry: 12.8
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 36.2,
    cy: 161.7,
    rx: 12.5,
    ry: 13.3
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 39,
    cy: 296.1,
    rx: 13,
    ry: 13.8
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 136.2,
    cy: 338.9,
    rx: 13.5,
    ry: 14.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M118.8,70.8c-8.4,0-15.3-7.3-15.3-16.2s6.9-16.2,15.3-16.2S134,45.6,134,54.6S127.2,70.8,118.8,70.8z  M118.8,43.3c-5.9,0-10.7,5.1-10.7,11.3s4.8,11.3,10.7,11.3s10.7-5.1,10.7-11.3S124.7,43.3,118.8,43.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M82.2,248.7c-10.3,0-18.7-8.9-18.7-19.9S71.9,209,82.2,209s18.7,8.9,18.7,19.9S92.5,248.7,82.2,248.7z  M82.2,214.7c-7.4,0-13.4,6.3-13.4,14.1s6,14.1,13.4,14.1s13.4-6.3,13.4-14.1S89.6,214.8,82.2,214.7L82.2,214.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155848207731941331200000004855656835305729920_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.9572,
    y1: 425.9143,
    x2: 325.4071,
    y2: 425.9143,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB2729"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1232F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155848207731941331200000004855656835305729920_)"
    },
    d: "M309.7,60.2c-8.7,0-15.7-7.5-15.7-16.7 s7-16.7,15.7-16.7s15.7,7.5,15.7,16.7S318.4,60.2,309.7,60.2z M309.7,31.7c-6.2,0-11.2,5.3-11.2,11.8s5,11.8,11.2,11.8 s11.2-5.3,11.2-11.8S315.9,31.7,309.7,31.7z"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M120.2,418.4c-7.9,0-14.2-6.8-14.2-15.2s6.4-15.2,14.2-15.2s14.3,6.8,14.3,15.2S128,418.4,120.2,418.4z  M120.2,394.6c-4.8-0.3-8.8,3.4-9.1,8.1c-0.3,4.8,3.4,8.8,8.1,9.1c4.8,0.3,8.8-3.4,9.1-8.1c0-0.2,0-0.3,0-0.5 C128.4,398.6,124.8,394.7,120.2,394.6z"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 69.6,
    cy: 355.9,
    rx: 13.9,
    ry: 14.8
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st15",
    cx: 96.1,
    cy: 291.7,
    rx: 11.2,
    ry: 11.9
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 179.4,
    cy: 429.1,
    rx: 13.9,
    ry: 14.8
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 26.5,
    cy: 228.9,
    rx: 10.5,
    ry: 11.1
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 357.5,
    cy: 83.1,
    rx: 13,
    ry: 13.8
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 312.8,
    cy: 117.4,
    rx: 10.3,
    ry: 10.9
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 245.2,
    cy: 433.5,
    rx: 14.3,
    ry: 15.2
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 255.3,
    cy: 359.6,
    rx: 16.6,
    ry: 17.6
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 191.2,
    cy: 364.1,
    rx: 14.3,
    ry: 15.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028323823115848068430000005744166500250276011_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.3072,
    y1: 159.5443,
    x2: 329.1872,
    y2: 159.5443,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0974B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#204E8A"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000028323823115848068430000005744166500250276011_)"
    },
    cx: 315.2,
    cy: 309.9,
    rx: 13.9,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061459744319810091330000016812147665473438876_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.6871,
    y1: 96.5043,
    x2: 378.3672,
    y2: 96.5043,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0974B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#204E8A"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000061459744319810091330000016812147665473438876_)"
    },
    cx: 364,
    cy: 372.9,
    rx: 14.3,
    ry: 15.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176746189075688675870000004584294996537798532_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.4372,
    y1: 54.4043,
    x2: 324.9171,
    y2: 54.4043,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0974B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#204E8A"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000176746189075688675870000004584294996537798532_)"
    },
    cx: 309.7,
    cy: 415,
    rx: 15.2,
    ry: 16.2
  }), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "171,417 141.4,355.2 145.5,353 175.1,414.8 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 366.8,
    y1: 333.6,
    x2: 279.4,
    y2: 325.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109751405598505581010000004733265748977683329_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.2612,
    y1: 412.6744,
    x2: 441.3112,
    y2: 411.0944,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109751405598505581010000004733265748977683329_)"
    },
    d: "M442.6,56.6c-0.9,0.6-1.8,1.3-2.7,1.9 L442.6,56.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005238157716192249730000010981215490013600411_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.6265,
    y1: 409.8843,
    x2: 437.6665,
    y2: 408.6043,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005238157716192249730000010981215490013600411_)"
    },
    d: "M438.7,59.4l-2.1,1.5L438.7,59.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152252081059962537330000012239511916377892789_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.3469,
    y1: 410.8343,
    x2: 439.3669,
    y2: 410.1343,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152252081059962537330000012239511916377892789_)"
    },
    d: "M439.9,58.5l-1.2,0.8l0.1-0.1L439.9,58.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034795100885077929470000013093216854210339232_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.4316,
    y1: 408.1245,
    x2: 435.4716,
    y2: 407.0544,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034795100885077929470000013093216854210339232_)"
    },
    d: "M436.3,61.2c-0.6,0.4-1.1,0.9-1.7,1.3 l0.5-0.4C435.5,61.8,435.9,61.5,436.3,61.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112612757941364389450000002048025756371831737_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.0544,
    y1: 401.7949,
    x2: 450.0443,
    y2: 312.1849,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112612757941364389450000002048025756371831737_)"
    },
    d: "M411.3,102.9l-10.6-8.4l1.2-1.3l1.4-1.6 l0.7-0.8c1.8-2,3.6-4,5.5-6c7.7-8.1,16.1-15.5,25-22.2l-1.2,0.9c-1.2,0.9-2.3,1.8-3.4,2.7l-1,0.9c-0.3,0.3-0.7,0.6-1,0.8l-1,0.8 l-1,0.9l-0.9,0.8l-1,0.8c-1,0.8-1.9,1.7-2.8,2.5l-0.1,0.1c-0.9,0.8-1.8,1.6-2.6,2.4c-0.3,0.3-0.6,0.5-0.9,0.8l-1.7,1.6l-1.7,1.6 l-0.8,0.8c-1.3,1.3-2.6,2.6-3.8,3.9c0.2,0.1,0.4,0.2,0.6,0.4c2.1,1.3,3.7,3.4,4.5,5.7c0.4,1.1,0.6,2.2,0.6,3.3c0,0.1,0,0.2,0,0.2 c0,1.2-0.2,2.3-0.5,3.4c-0.6,1.8-1.6,3.4-3,4.7l67.2,54.1c1.7-3.6,5.4-6,9.4-6h0.1c2,0,3.9,0.6,5.5,1.6c1.2,0.8,2.3,1.8,3.1,2.9 l-2.8,3.1l-5.6,6.2l-9.8-7.8L411.3,102.9z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M558.4,70.7c0,0.9,0.1,1.8,0.3,2.6l-66,16.9c-0.1-0.4-0.2-0.9-0.4-1.3c-0.5-1.6-1.4-3.1-2.7-4.3l40.6-55.8 c1.9,1.9,4.5,2.9,7.2,2.9c2.4,0,4.7-0.8,6.5-2.3l19.3,32C560.2,63.5,558.3,67,558.4,70.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M491.7,91.9l-0.3-1.3c-0.1-0.4-0.2-0.8-0.3-1.1c-0.5-1.4-1.3-2.7-2.3-3.8l-0.8-0.8l42.1-57.9l1,1 c1.7,1.6,4,2.6,6.4,2.6c2.1,0,4.1-0.7,5.7-2l1.1-0.9l20.8,34.3l-1.1,0.7c-2.8,1.8-4.5,4.8-4.4,8.1c0,0.8,0.1,1.6,0.3,2.3l0.3,1.3 L491.7,91.9z M491.4,84.6c1,1.2,1.7,2.5,2.2,4v0.1l63.6-16.3c-0.1-0.5-0.1-1.1-0.1-1.7c0-3.7,1.7-7.3,4.6-9.6l-18-29.8 c-1.8,1.2-4,1.8-6.2,1.8c-2.5,0-5-0.8-7-2.4L491.4,84.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021824973972513181590000000531022493559184525_",
    gradientUnits: "userSpaceOnUse",
    x1: 482.0038,
    y1: 386.6345,
    x2: 482.6338,
    y2: 367.8145,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021824973972513181590000000531022493559184525_)"
    },
    d: "M471.7,92.8c0-0.1,0-0.2,0-0.3 c-0.1-5.9,4.7-10.8,10.6-10.9c2,0,3.9,0.6,5.5,1.6c0.7,0.4,1.3,0.9,1.8,1.4c1.2,1.2,2.1,2.7,2.7,4.3c0.1,0.4,0.3,0.9,0.4,1.3 c0.1,0.7,0.2,1.5,0.2,2.2c0,1.2-0.2,2.3-0.5,3.4c-0.2,0.7-0.5,1.4-0.9,2.1c-1.4,2.5-3.9,4.4-6.7,5.1c-0.8,0.2-1.6,0.3-2.5,0.3 C476.5,103.3,471.8,98.6,471.7,92.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131327898364312118620000000682998051670474685_",
    gradientUnits: "userSpaceOnUse",
    x1: 568.6431,
    y1: 408.3938,
    x2: 569.2731,
    y2: 389.5838,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131327898364312118620000000682998051670474685_)"
    },
    d: "M558.7,73.4c-0.2-0.9-0.3-1.8-0.3-2.6 c0-3.7,1.9-7.2,5-9.3c3.4-2.2,7.7-2.2,11.2,0c1.8,1.2,3.3,2.8,4.1,4.8c0.1,0.3,0.3,0.6,0.4,0.9c0.4,1.1,0.6,2.3,0.6,3.5 c0,1.2-0.2,2.3-0.5,3.4c0,0.2-0.1,0.4-0.2,0.5c-0.7,1.8-1.8,3.4-3.3,4.6c-0.2,0.2-0.4,0.3-0.7,0.5c-3.2,2.2-7.4,2.5-10.8,0.7 C561.4,79,559.4,76.4,558.7,73.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008860885045119187070000016886853807153351833_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.2629,
    y1: 349.6342,
    x2: 537.733,
    y2: 335.7841,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008860885045119187070000016886853807153351833_)"
    },
    d: "M530.2,134.6c-0.6,0.2-1.2,0.4-1.8,0.6 c-1.8-3.2-1.9-7.1-0.2-10.4c1.8-3.6,5.4-5.9,9.5-5.9c2,0,3.9,0.6,5.5,1.6c0.2,0.1,0.5,0.3,0.7,0.5c1.8,1.3,3.1,3.2,3.8,5.2 c0.2,0.6,0.4,1.2,0.5,1.8c0.1,0.6,0.1,1.1,0.1,1.7c0,0.1,0,0.3,0,0.4c-1.2,0.2-2.4,0.4-3.6,0.6l0,0c-2.1,0.4-4.2,0.9-6.3,1.4l0,0 l0,0c-2.7,0.7-5.4,1.5-8,2.4L530.2,134.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147191835005965674510000014853472306201882258_",
    gradientUnits: "userSpaceOnUse",
    x1: 628.4321,
    y1: 385.3948,
    x2: 629.0621,
    y2: 366.5848,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147191835005965674510000014853472306201882258_)"
    },
    d: "M619.1,98.4c-0.7-1.5-1-3.1-1-4.7 c0-1.1,0.2-2.3,0.5-3.4c1.4-4.4,5.5-7.5,10.1-7.5c2,0,3.9,0.6,5.5,1.6c2.1,1.3,3.7,3.4,4.5,5.7c0.4,1.1,0.6,2.3,0.6,3.5 c0,1.2-0.2,2.3-0.5,3.4c-0.1,0.2-0.1,0.4-0.2,0.6c-0.7,1.8-1.8,3.3-3.2,4.5c-1.9,1.5-4.2,2.4-6.6,2.4c-1,0-2-0.2-3-0.5l0,0 C622.8,103.3,620.4,101.2,619.1,98.4z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M686.7,110.6L686.7,110.6c0-1.2-0.2-2.4-0.6-3.5c-0.7-2-1.9-3.7-3.5-5l15.5-20.3c3.9,3.1,9.3,3.1,13.2-0.1 c0.6-0.5,1.1-1,1.5-1.6c9.6,9.5,18.3,19.8,25.9,30.8L686.7,110.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061467622828463639400000001399138410416089740_",
    gradientUnits: "userSpaceOnUse",
    x1: 618.8405,
    y1: 448.8438,
    x2: 620.8505,
    y2: 388.4537,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061467622828463639400000001399138410416089740_)"
    },
    d: "M530.3,28.9c-1.9-1.8-3.1-4.3-3.3-6.9 c3.1-0.5,6.2-1,9.4-1.4l2.2-0.3c1.7-0.2,3.4-0.4,5.1-0.5l0,0c1.5-0.1,2.9-0.3,4.4-0.4c29.7-2.1,59.4,2,87.4,12l0.3,0.1 c6.7,2.4,13.3,5.1,19.7,8.2c8.5,4,16.6,8.7,24.5,13.8c5.8,3.8,11.4,7.9,16.8,12.2c5.6,4.5,10.9,9.2,16,14.3c-0.5,0.6-1,1.1-1.5,1.6 c-3.8,3.1-9.3,3.2-13.2,0.1c-4.7-3.8-5.5-10.8-1.7-15.5c-12.7-10.2-26.4-19-41.1-26.1l0,0c-1.6,3.9-5.4,6.4-9.7,6.4 c-1,0-2-0.2-3-0.4c-3-0.9-5.4-3.1-6.7-6c-0.6-1.4-0.9-2.9-0.9-4.5c0-0.5,0-1.1,0.1-1.6l-87-13.4v0.5c0,1.2-0.2,2.3-0.5,3.4 c-0.6,2-1.8,3.8-3.4,5.1l-0.1,0.1c-1.8,1.5-4.1,2.3-6.5,2.3C534.8,31.8,532.2,30.7,530.3,28.9z"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M738.7,110.8L694,121.4l-8.7-5.3c0.4-0.7,0.7-1.4,0.9-2.2c0.4-1.1,0.6-2.2,0.5-3.4L738.7,110.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M765.9,164.6l-35.6,4.8l8.5-58.6c0.9,1.3,1.8,2.7,2.8,4.1c0.6,0.9,1.2,1.9,1.9,2.9c0.4,0.7,0.9,1.4,1.3,2 c0.3,0.5,0.6,1,1,1.5l1,1.7c0.3,0.6,0.7,1.1,1,1.7c0.2,0.4,0.5,0.8,0.7,1.2c0.6,1,1.2,2,1.8,3.1c1.2,2.2,2.4,4.4,3.6,6.7l0.9,1.7 c0.3,0.6,0.6,1.1,0.8,1.7s0.6,1.1,0.8,1.7l0.6,1.3c0.2,0.4,0.4,0.8,0.6,1.3l0.6,1.2c0.2,0.5,0.4,1,0.7,1.4s0.4,1,0.6,1.4 c0.8,1.8,1.5,3.5,2.2,5.3c0.3,0.9,0.7,1.7,1,2.5c0.6,1.5,1.2,3,1.7,4.5l0.6,1.7l0,0C765.1,162.5,765.5,163.6,765.9,164.6z"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "738.7,110.8 730.2,169.4 701.3,153.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042710587864906034290000015009948026484198017_",
    gradientUnits: "userSpaceOnUse",
    x1: 675.8142,
    y1: 368.6349,
    x2: 676.4342,
    y2: 349.8248,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042710587864906034290000015009948026484198017_)"
    },
    d: "M666.5,115.2c-1.2-2.5-1.4-5.4-0.5-8.1 c0.9-3,3.1-5.4,6-6.6c3.1-1.3,6.7-1,9.6,0.8c0.3,0.2,0.7,0.4,1,0.7c1.6,1.3,2.9,3,3.5,5c0.4,1.1,0.6,2.3,0.6,3.5l0,0 c0,1.1-0.2,2.3-0.5,3.4c-0.2,0.8-0.5,1.5-0.9,2.2c-0.6,1.1-1.5,2.1-2.5,2.9c-3.8,3.2-9.3,3.2-13.2,0.1 C668.3,118,667.2,116.7,666.5,115.2z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M656.3,136.5l-6.3,39.3c-0.5-0.8-1.1-1.6-1.7-2.4c-7-10-15.7-18.8-25.7-25.8c0.8-1,1.5-2.2,1.9-3.5 c0.4-1.1,0.6-2.2,0.5-3.4c0-0.4,0-0.7,0-1.1L656.3,136.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114792495775731442390000009525791880216480428_",
    gradientUnits: "userSpaceOnUse",
    x1: 614.2889,
    y1: 338.653,
    x2: 614.8189,
    y2: 323.033,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114792495775731442390000009525791880216480428_)"
    },
    d: "M609.9,140.1c-1.8-0.9-3.8-1.8-5.7-2.6 c0.8-2.6,2.6-4.9,5-6.2c2.5-1.5,5.6-1.8,8.4-0.9c0.8,0.3,1.6,0.6,2.3,1.1c1.8,1.1,3.1,2.7,4,4.6c0.5,1.1,0.9,2.4,1,3.6 c0,0.4,0,0.7,0,1.1c0,1.2-0.2,2.3-0.5,3.4c-0.4,1.3-1,2.5-1.9,3.5C618.5,144.8,614.2,142.3,609.9,140.1z"
  }), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "701.3,153.6 649.9,175.8 656.3,136.5 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111185229419063033480000002197178145146184890_",
    gradientUnits: "userSpaceOnUse",
    x1: 712.2404,
    y1: 272.3943,
    x2: 712.5804,
    y2: 233.2343,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#55AFD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#55B0D5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111185229419063033480000002197178145146184890_)"
    },
    points: "730.2,169.4 715.8,225 694,194 "
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M667.2,236.5c0.3-8.4-0.5-16.9-2.3-25.1l29-17.4L667.2,236.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155857380768729354860000006813028237869196934_",
    gradientUnits: "userSpaceOnUse",
    x1: 654.4631,
    y1: 292.7748,
    x2: 654.9931,
    y2: 276.9248,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155857380768729354860000006813028237869196934_)"
    },
    d: "M659.5,193.9c-1.8-4.5-4-8.8-6.4-12.9l0,0 c-1-1.7-2-3.4-3.2-5.1c3.8,5.6,6.9,11.6,9.5,17.9C659.5,193.7,659.5,193.8,659.5,193.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018954064613037310220000013334783621558906031_",
    gradientUnits: "userSpaceOnUse",
    x1: 587.6831,
    y1: 228.5241,
    x2: 593.9631,
    y2: 40.6042,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018954064613037310220000013334783621558906031_)"
    },
    d: "M775.3,261.5c-0.4,3.2-0.9,6.4-1.5,9.6 c-18.1,101.7-106.3,176-209.7,176.4c-12.7,0-25.4-1.1-37.9-3.4c-38.3-6.8-73.9-24-103.1-49.7c-22.7-20.1-24.8-54.8-4.7-77.5 c1.1-1.2,2.2-2.4,3.4-3.5l0.5-0.4c6.5-6.2,14.4-10.7,23-13.1c17.6-4.9,36.4-0.6,50.2,11.5c43,37.7,108.4,33.4,146.1-9.6 c11.7-13.4,19.8-29.5,23.4-46.9l29-18.5l22.4,12.6l-0.6-24.1l32.3,8.2L775.3,261.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007388362672606590510000007654400913854357644_",
    gradientUnits: "userSpaceOnUse",
    x1: 777.0111,
    y1: 243.2434,
    x2: 777.071,
    y2: 241.5034,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54AEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#61B4C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#6DBAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7AC47F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007388362672606590510000007654400913854357644_)"
    },
    d: "M777.1,228.1l-0.1-2c0,0.6,0,1.1,0,1.7 C777.1,227.9,777.1,228,777.1,228.1z"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M415.4,94.4c0,1.2-0.2,2.3-0.5,3.4c-0.6,1.8-1.6,3.4-3,4.7c-0.2,0.1-0.3,0.3-0.5,0.4l0,0 c-1.9,1.5-4.2,2.4-6.6,2.4c-6-0.2-10.7-5.2-10.6-11.2c0.2-5.8,4.8-10.4,10.6-10.6c1.7,0,3.4,0.4,4.9,1.2l0,0 c0.2,0.1,0.4,0.2,0.6,0.4c2.1,1.3,3.7,3.4,4.5,5.7c0.4,1.1,0.6,2.2,0.6,3.3C415.3,94.2,415.3,94.3,415.4,94.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M495.9,92.5c0,1.3-0.2,2.6-0.6,3.8c-0.2,0.8-0.6,1.6-1,2.4c-0.8,1.3-1.7,2.5-2.9,3.4c-2.2,1.7-4.9,2.7-7.7,2.7 c-6.6,0-12.1-5.3-12.2-11.9c0-0.1,0-0.2,0-0.3c0-6.8,5.5-12.2,12.3-12.2c2.2,0,4.4,0.6,6.4,1.8c0.8,0.5,1.5,1,2.1,1.6 c1.4,1.3,2.5,3,3.1,4.8c0.2,0.5,0.3,1,0.4,1.5C495.9,90.8,495.9,91.7,495.9,92.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M581.2,70.9c0,1.3-0.2,2.6-0.6,3.8c-0.1,0.2-0.1,0.4-0.2,0.6c-0.8,2-2.1,3.8-3.8,5.1c-0.2,0.2-0.5,0.4-0.8,0.6 c-5.5,3.9-13.1,2.5-17-3c-1.4-2.1-2.2-4.5-2.2-7c0-4.2,2.2-8.1,5.8-10.3c4-2.4,8.9-2.4,12.9,0c2.1,1.3,3.8,3.1,4.8,5.3 c0.2,0.3,0.3,0.7,0.4,1C581,68.2,581.3,69.6,581.2,70.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M549.8,20.9c0,1.3-0.2,2.6-0.6,3.8c-0.7,2.2-2.1,4.2-4,5.7l-0.1,0.1c-2.2,1.7-4.8,2.6-7.5,2.6 c-3.1,0-6.1-1.1-8.4-3.2c-2.2-2-3.6-4.7-3.8-7.6c0-0.4,0-0.8,0-1.2c0-0.2,0-0.3,0-0.5c0.4-6.8,6.2-11.9,12.9-11.6 c2,0.1,4,0.7,5.7,1.8c2.4,1.4,4.2,3.7,5.2,6.4c0.1,0.2,0.1,0.3,0.2,0.5c0.2,0.6,0.3,1.1,0.4,1.7c0.1,0.4,0.1,0.8,0.1,1.2 C549.8,20.6,549.8,20.7,549.8,20.9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M500.8,160.1c0,1.3-0.2,2.6-0.6,3.8c-0.7,2.2-2.1,4.2-4,5.7c-5.3,4.2-13.1,3.3-17.3-2 c-1.7-2.1-2.6-4.7-2.6-7.4c0-1.8,0.4-3.6,1.2-5.3v-0.1c2.1-4.1,6.3-6.7,10.9-6.7h0.1c2.3,0,4.5,0.6,6.4,1.8c1.4,0.8,2.6,1.9,3.5,3.2 c0.2,0.3,0.5,0.7,0.7,1l0,0c0.4,0.7,0.7,1.4,1,2.1C500.5,157.4,500.8,158.8,500.8,160.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M549.9,129.8c0,0.1,0,0.3,0,0.5c0,0.4-0.1,0.8-0.1,1.2c-0.1,0.7-0.3,1.4-0.5,2.1c-0.7,2.2-2.1,4.2-4,5.7 c-5.3,4.2-13.1,3.3-17.3-2c-0.2-0.3-0.5-0.6-0.7-0.9c-0.1-0.1-0.2-0.3-0.3-0.4c-1.1-1.8-1.7-3.9-1.7-6c0-1.9,0.5-3.8,1.4-5.5 c3.2-6,10.7-8.3,16.7-5.1c0.2,0.1,0.4,0.2,0.6,0.4c0.3,0.2,0.5,0.4,0.8,0.5c2,1.4,3.5,3.5,4.4,5.8c0.2,0.6,0.4,1.3,0.5,2 C549.8,128.6,549.8,129.2,549.9,129.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M641,93.7c0,1.3-0.2,2.6-0.6,3.8c-0.1,0.2-0.2,0.4-0.2,0.7c-0.8,2-2.1,3.7-3.7,5c-2.2,1.7-4.9,2.7-7.7,2.6 c-1.2,0-2.4-0.2-3.5-0.5l0,0c-3.3-1-6.1-3.3-7.6-6.4c-1.3-2.8-1.5-6-0.6-8.9c1.7-5,6.4-8.3,11.7-8.3c1.2,0,2.5,0.2,3.7,0.6 c1,0.3,1.9,0.7,2.8,1.2c2.4,1.4,4.2,3.7,5.2,6.4C640.8,91.1,641,92.4,641,93.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M688.4,109.9L688.4,109.9c0,1.3-0.2,2.6-0.6,3.8c-0.3,0.8-0.6,1.6-1.1,2.4c-0.8,1.3-1.7,2.4-2.9,3.3 c-4.5,3.5-10.7,3.5-15.2,0.1c-3-2.3-4.7-5.8-4.7-9.5c0-1.3,0.2-2.6,0.6-3.8c1.1-3.3,3.7-6,6.9-7.4c3.6-1.5,7.8-1.2,11.1,0.9 c0.4,0.2,0.8,0.5,1.1,0.8c1.9,1.4,3.3,3.4,4,5.6C688.2,107.2,688.4,108.5,688.4,109.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M715.5,72.3c0,1.3-0.2,2.6-0.6,3.8c-0.5,1.4-1.2,2.8-2.2,3.9c-0.5,0.6-1.1,1.2-1.8,1.7 c-4.4,3.5-10.7,3.5-15.2,0.1c-3-2.3-4.7-5.8-4.7-9.5c0-2.8,1-5.5,2.8-7.6c0.1-0.1,0.2-0.3,0.4-0.4c4-4.3,10.5-5.2,15.5-2.2 c2.4,1.4,4.2,3.7,5.2,6.4C715.3,69.7,715.6,71,715.5,72.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M625,140.7c0,1.2-0.2,2.3-0.5,3.4c-0.4,1.3-1,2.5-1.9,3.5c-2,2.5-5,4-8.2,4c-5.9-0.1-10.7-4.9-10.6-10.9 c0,0,0,0,0,0c0-0.5,0-1,0.1-1.5c0.1-0.6,0.2-1.2,0.4-1.8c0.8-2.6,2.6-4.9,5-6.2c2.5-1.5,5.6-1.8,8.4-0.9c0.8,0.3,1.6,0.6,2.3,1.1 c1.8,1.1,3.1,2.7,4,4.6c0.5,1.1,0.9,2.4,1,3.6C625,140,625,140.3,625,140.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M657.9,35.5c0,1.3-0.2,2.6-0.6,3.8c-0.1,0.3-0.2,0.6-0.3,0.9c0,0.1-0.1,0.2-0.1,0.3l0,0 c-0.8,1.8-2,3.3-3.5,4.5c-0.9,0.7-1.9,1.3-2.9,1.7c-2.6,1.1-5.5,1.2-8.2,0.4c-3.4-1-6.2-3.4-7.7-6.6c-0.7-1.6-1.1-3.2-1.1-4.9 c0-0.6,0-1.2,0.1-1.8c0.1-0.9,0.4-1.8,0.8-2.7l0,0c2.6-6.3,9.9-9.2,16.2-6.6c0.6,0.2,1.1,0.5,1.6,0.8c2.4,1.4,4.3,3.7,5.2,6.4 C657.7,32.8,657.9,34.2,657.9,35.5z"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "485,93.3 483,91.7 488.7,83.9 490.7,85.5 "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "531.3,29.7 529.3,28.1 536.6,18 538.6,19.6 "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M564.1,80.4L543.9,121c-0.2-0.2-0.5-0.3-0.7-0.5c-1.7-1.1-3.6-1.6-5.5-1.6c-4,0-7.7,2.3-9.5,5.9L491.5,98 c0.4-0.7,0.7-1.4,0.9-2.1c0.4-1.1,0.6-2.2,0.5-3.4c0-0.7-0.1-1.5-0.2-2.2l66-16.9C559.4,76.4,561.4,79,564.1,80.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M528.6,126.8l-38.8-28.4l0.6-1c0.3-0.6,0.6-1.2,0.8-1.8c0.3-1,0.5-2,0.5-3c0-0.7-0.1-1.3-0.2-2l-0.3-1.2 l68.4-17.5l0.3,1.3c0.6,2.7,2.4,4.9,4.8,6.2l1.1,0.6L544.3,123l-1.2-0.9c-0.2-0.1-0.4-0.3-0.6-0.4c-1.5-0.9-3.2-1.4-4.9-1.4 c-3.5,0-6.7,2-8.3,5.2L528.6,126.8z M493.1,97.6l34.6,25.4c2.2-3.3,5.9-5.3,9.8-5.3c2,0,4,0.5,5.8,1.5l19.1-38.2 c-2.1-1.5-3.8-3.6-4.7-6l-63.6,16.3c0,0.4,0.1,0.8,0.1,1.2c0,1.3-0.2,2.6-0.6,3.8C493.5,96.8,493.3,97.2,493.1,97.6z"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "559,74.7 558.4,72.1 568.7,69.5 569.3,72 "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "484.3,93.8 483.7,91.2 492.4,89 493,91.6 "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "490.7,99.1 483.3,93.6 484.7,91.4 492.2,96.9 "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "537.5,133.3 527.4,125.9 528.9,123.8 539.2,131.3 538.3,132.2 "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "539.6,133.6 538.3,132.2 536.6,131.3 542.2,120.1 545.6,121.9 539.8,133.4 "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "565.8,81.3 562.4,79.5 567.3,69.8 570.7,71.6 "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "567.4,71.8 561.8,62.5 565,60.4 570.6,69.7 "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "542.4,30.5 536,19.9 539.2,17.8 545.7,28.4 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 489,
    y1: 158.5,
    x2: 488.4,
    y2: 150.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 484.8,
    y1: 103.1,
    x2: 484,
    y2: 92.5
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "471.7,94.1 471.7,91.5 484,91.2 484,93.8 "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "402,95.8 401.9,93.1 415.3,92.8 415.4,95.4 "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "483.5,103.2 482.7,92.6 485.3,92.4 486.1,103 "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "488,161.6 487.2,150.6 489.7,150.4 490.6,161.4 "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M530.3,28.9l-40.6,55.9c-0.5-0.5-1.2-1-1.8-1.4c-1.7-1.1-3.6-1.6-5.5-1.6c-5.9,0.1-10.7,4.9-10.6,10.9 c0,0.1,0,0.2,0,0.3l-56.4,1.3c0-1.1-0.2-2.2-0.6-3.3c-0.8-2.4-2.4-4.4-4.5-5.7c-0.2-0.1-0.4-0.2-0.6-0.4c1.2-1.3,2.5-2.6,3.8-3.9 l0.8-0.8l1.7-1.6l1.7-1.6c0.3-0.3,0.6-0.6,0.9-0.8c0.9-0.8,1.7-1.6,2.6-2.4l0.1-0.1c0.9-0.8,1.8-1.6,2.8-2.5l1-0.8l0.9-0.8l1-0.9 l1-0.8c0.3-0.3,0.7-0.6,1-0.8l1-0.9c1.1-0.9,2.3-1.8,3.4-2.7l0.4-0.3l0.8-0.6l0.5-0.4c1.2-0.9,2.4-1.8,3.6-2.7l0.1-0.1l0.1-0.1 l1.1-0.8l1.3-1l0.2-0.1l1.2-0.8l1.2-0.8c1-0.7,2.1-1.4,3.1-2.1c24.2-15.9,51.5-26.8,80-31.8C527.2,24.6,528.4,27.1,530.3,28.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M414.1,95.5v-1.3c0-1-0.2-1.9-0.5-2.8c-0.7-2.1-2.1-3.9-3.9-5.1c-0.2-0.1-0.4-0.2-0.6-0.3l-1.5-0.9l1.2-1.2 c1.3-1.3,2.5-2.6,3.8-3.9l0.8-0.8l1.7-1.6l1.7-1.6l0.2-0.2c0.2-0.2,0.5-0.4,0.7-0.6c0.8-0.8,1.7-1.6,2.6-2.4l0.1-0.1 c0.9-0.8,1.9-1.7,2.8-2.5l1-0.9l1-0.9l1-0.8c0.3-0.3,0.7-0.6,1-0.8s0.7-0.6,1-0.9s0.7-0.6,1-0.8c1.1-0.9,2.2-1.8,3.4-2.7l1.6-1.2 c1.1-0.9,2.3-1.7,3.7-2.7h0.1l0.1-0.1l1.1-0.8l1.3-0.9l0.2-0.2l1-0.7l0.1-0.1c0.4-0.3,0.8-0.6,1.2-0.8c1-0.7,2.1-1.4,3.1-2.1 c24.4-16.1,51.8-26.9,80.5-31.9l1.3-0.2l0.1,1.4c0.2,2.3,1.3,4.4,2.9,6.1l0.8,0.8l-42.1,57.9l-1-1c-0.5-0.5-1-0.9-1.6-1.3 c-1.5-0.9-3.2-1.4-4.9-1.4c-5.2,0.1-9.4,4.3-9.3,9.6v0.2l0.1,1.4L414.1,95.5z M411.7,84.5c2,1.5,3.5,3.5,4.3,5.9 c0.3,0.8,0.5,1.6,0.6,2.4l53.9-1.3c0.4-6.3,5.6-11.1,11.9-11.2c2.2,0,4.4,0.6,6.2,1.8c0.3,0.2,0.6,0.4,0.9,0.6L528.6,29 c-1.4-1.6-2.3-3.5-2.7-5.5c-27.9,5.1-54.6,15.7-78.3,31.4c-1,0.7-2.1,1.4-3.1,2.1c-0.4,0.2-0.8,0.5-1.1,0.8l-0.1,0.1l-1,0.7 l-0.2,0.1c-0.5,0.3-0.9,0.6-1.3,1l-1.2,0.9c-1.3,1-2.5,1.9-3.6,2.7l-1.6,1.2c-1.2,0.9-2.3,1.8-3.4,2.7c-0.4,0.3-0.7,0.6-1,0.8 l-1,0.8l-1,0.9l-0.9,0.8l-1,0.9l-0.9,0.8l0,0c-1,0.8-1.9,1.6-2.8,2.4l-0.1,0.1c-0.9,0.8-1.8,1.6-2.6,2.4l-0.7,0.6l-0.2,0.2l-1.7,1.6 l-1.6,1.6l-0.8,0.8C413.5,82.7,412.6,83.6,411.7,84.5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M703.8,74c-2.7-2.4-5.4-4.7-8.2-6.9l1.6-2.1c2.8,2.2,5.5,4.6,8.2,7L703.8,74z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M403.7,94.4l-1.9-1.8c16.3-18.3,35.4-33.8,56.6-46c0.3-0.2,34.1-19.4,67.7-25.5c3.6-0.7,7.2-1.2,10.8-1.6 s6.9-0.8,10.2-1c29.6-2.1,59.3,2.4,88.3,13.6l0.3,0.1c3.9,1.5,7.2,2.9,9.9,4.1c3.3,1.4,6.5,2.9,9.7,4.5l-1.1,2.4 c-3.2-1.6-6.4-3-9.6-4.4c-2.7-1.1-5.9-2.5-9.8-4l-0.3-0.1c-28.6-11-58-15.5-87.2-13.4c-3.2,0.2-6.6,0.6-10,1s-7,1-10.6,1.6 c-33.2,6-66.5,25.1-66.9,25.3C438.7,61,419.8,76.4,403.7,94.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M402.9,94.1l-1.9-1.8l1.4-1.6c2-2.3,4.2-4.6,6.3-6.9l1.8,1.9c-2.1,2.2-4.2,4.5-6.2,6.8L402.9,94.1z"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "569.5,71.9 568.5,69.5 578.1,65.1 579.2,67.5 "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "636.5,41.2 635.5,38.8 645.1,34.3 646.2,36.7 "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "643.9,46.3 641.4,45.6 644.4,35.1 646.9,35.9 "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "630,94.8 627.5,94 630.7,83 633.1,83.7 "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "627.5,104.8 623.9,103.6 626.9,93.8 630.6,95 "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "616.2,141.3 612.5,140.1 615.8,129.7 619.4,130.9 "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "638,99.6 628.1,96.3 629.3,92.5 639.2,95.9 "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "675.5,112.4 665.4,108.9 666.6,105.2 676.7,108.6 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 680.2,
    y: 105.2,
    transform: "matrix(4.363309e-03 -1 1 4.363309e-03 567.9549 791.5317)",
    className: "st29",
    width: 2.6,
    height: 10.6
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "648.6,46.1 644.5,36 646.8,35 650.9,45 "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "674.9,111 670.9,101 673.2,99.9 677.3,110 "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "667.1,116.4 666,114 675.6,109.3 676.7,111.7 "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "614.9,141.9 613.8,139.5 623.4,134.8 624.5,137.2 "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "578.2,76.5 568.3,72.6 569.7,68.9 579.6,72.8 "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "628,96.2 617.9,92.2 619.3,88.5 629.4,92.5 "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M528.4,135.3c-9.3,3.4-18.1,8.1-26.1,14l-5.2,5.8c-0.8-1.2-1.9-2.2-3.1-2.9c-1.7-1.1-3.6-1.6-5.5-1.6h-0.1 l-3.6-47.4c2.8-0.7,5.2-2.6,6.7-5.1l36.7,26.8C526.5,128.1,526.6,132,528.4,135.3L528.4,135.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M497,157.2l-0.9-1.3c-0.7-1-1.6-1.9-2.7-2.6c-1.5-0.9-3.2-1.4-4.9-1.4h-1.3l-3.8-49.8l1.1-0.3 c1.3-0.3,2.6-1,3.6-1.8c0.9-0.7,1.7-1.6,2.2-2.6l0.7-1.2l38.8,28.3l-0.5,1c-1.5,2.9-1.4,6.3,0.2,9.2l0.8,1.4l-1.5,0.5 c-9.2,3.4-17.8,8-25.6,13.8L497,157.2z M489.6,149.3c2.9,0.3,5.6,1.7,7.6,3.8l4.4-4.8c7.7-5.7,16.1-10.3,25-13.7 c-0.6-1.5-0.9-3.1-0.9-4.7c0-1.6,0.3-3.1,0.8-4.5l-34.7-25.4c-1.4,1.9-3.4,3.4-5.7,4.2L489.6,149.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M609.2,131.2c-2.4,1.4-4.2,3.6-5,6.2c-17.6-7.5-37-10-56-7.2c0-0.1,0-0.3,0-0.4c0-0.6,0-1.1-0.1-1.7l46.2-19.3 L609.2,131.2z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M605,139.2l-1.3-0.5c-17.4-7.4-36.6-9.9-55.3-7.1l-1.5,0.2l0.1-1.6v-0.3c0-0.5,0-1-0.1-1.5l-0.2-1l48.1-20.1 l16.3,24.5l-1.2,0.7c-2.1,1.2-3.7,3.2-4.4,5.5L605,139.2z M563.3,127.8c6.1,0,12.1,0.5,18.1,1.6c7.5,1.3,14.9,3.4,22,6.4 c0.8-2,2.2-3.7,3.9-4.9l-13.5-20.4l-43.5,18.2C554.6,128.1,559,127.8,563.3,127.8z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M625.7,104.2l-8.1,26.2c-2.8-0.9-5.8-0.6-8.4,0.9l-14.9-22.4l24.8-10.4C620.4,101.2,622.8,103.3,625.7,104.2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M608.9,132.9l-16.5-24.7l27.4-11.5l0.5,1.1c1.1,2.4,3.2,4.3,5.8,5.1l1.2,0.4l-8.9,28.7l-1.2-0.4 c-2.4-0.8-5.1-0.5-7.4,0.8L608.9,132.9z M596.3,109.4l13.4,20.1c2.2-1,4.7-1.3,7.1-0.8l7.4-23.8c-2.3-1-4.3-2.7-5.5-4.9L596.3,109.4 z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 614.4,
    y1: 138.9,
    x2: 609.2,
    y2: 131.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M642.7,45.3l-10.8,37.4c-1-0.3-2.1-0.5-3.2-0.5c-4.6,0-8.7,3.1-10.1,7.5L578.9,74c0.1-0.2,0.1-0.3,0.2-0.5 c0.4-1.1,0.6-2.2,0.5-3.4c0-1.2-0.2-2.4-0.6-3.5c-0.1-0.3-0.2-0.6-0.4-0.9L636,39.3C637.2,42.2,639.7,44.4,642.7,45.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M672,100.5c-2.9,1.2-5.1,3.7-6,6.6l-27.4-9.4c0.1-0.2,0.1-0.4,0.2-0.6c0.4-1.1,0.6-2.2,0.5-3.4 c0-1.2-0.2-2.4-0.6-3.5c-0.8-2.4-2.4-4.4-4.5-5.7c-0.7-0.5-1.5-0.9-2.4-1.1l10.8-37.4c1,0.3,2,0.4,3,0.4c1.4,0,2.8-0.3,4.1-0.8 L672,100.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M666.9,108.7l-30-10.2l0.5-1.3c0.1-0.2,0.1-0.3,0.2-0.5c0.3-1,0.5-2,0.5-3c0-3.3-1.7-6.4-4.5-8.1 c-0.7-0.4-1.4-0.8-2.1-1l-1.2-0.4l11.6-39.9l1.2,0.4c2.1,0.6,4.3,0.5,6.2-0.3l1.2-0.5l23.3,57.3l-1.2,0.5c-2.5,1.1-4.4,3.2-5.3,5.8 L666.9,108.7z M640.2,96.9l25.1,8.5c1.1-2.4,2.8-4.4,5.1-5.6L649,47.2c-1.8,0.5-3.7,0.6-5.5,0.3l-10.1,35.1c0.5,0.2,1,0.5,1.5,0.8 c2.4,1.5,4.1,3.8,5,6.4C640.7,92.1,640.8,94.6,640.2,96.9L640.2,96.9z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M698.1,81.6l-15.5,20.3c-0.3-0.3-0.7-0.5-1-0.7c-2.9-1.8-6.5-2.1-9.6-0.8l-22.3-54.9c2.5-1.1,4.5-3.1,5.6-5.6 l0,0c14.6,7.2,28.4,15.9,41.1,26.1C692.6,70.8,693.3,77.8,698.1,81.6L698.1,81.6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M682.9,103.8l-1-0.8c-2.6-2.1-6.2-2.6-9.3-1.3l-1.2,0.5l-23.3-57.3l1.2-0.5c0.8-0.3,1.6-0.8,2.2-1.4 c1.2-1,2.1-2.2,2.7-3.6l0.3-0.8h1.1l0.3,0.1c14.7,7.2,28.6,16,41.3,26.3l1,0.8l-0.8,1c-3.4,4.2-2.7,10.3,1.5,13.7l1,0.8L682.9,103.8 z M676.1,98.3c2.2,0,4.4,0.6,6.2,1.8l0,0l14-18.4c-2.3-2.3-3.6-5.5-3.6-8.8c0-2.4,0.7-4.7,1.9-6.7c-12-9.5-25-17.8-38.7-24.6 c-0.7,1.3-1.7,2.4-2.8,3.4c-0.5,0.4-1.1,0.8-1.7,1.2l21.3,52.6C673.8,98.5,675,98.3,676.1,98.3z"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "677.1,111.3 675.1,109.7 681.6,101.1 683.6,102.7 "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "699.1,82.4 697.1,80.8 703.6,72.2 705.6,73.8 "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M594.3,108.8l-46.2,19.3c-0.1-0.6-0.2-1.2-0.5-1.8c-0.7-2.1-2-3.9-3.8-5.2l20.3-40.6c3.5,1.8,7.6,1.5,10.8-0.7 L594.3,108.8z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M547.1,130l-0.3-1.6c-0.1-0.5-0.2-1.1-0.4-1.6c-0.6-1.9-1.8-3.5-3.3-4.6l-0.9-0.7l21.4-42.7l1.1,0.6 c3,1.6,6.7,1.4,9.5-0.6l1-0.7l21,31.5L547.1,130z M545.5,120.7c1.6,1.4,2.7,3.2,3.4,5.2c0.1,0.1,0.1,0.3,0.2,0.5l43.4-18.1 l-17.8-26.7c-3,1.7-6.6,1.9-9.9,0.6L545.5,120.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M619.1,98.4l-24.8,10.4L575,79.7c0.2-0.2,0.4-0.3,0.7-0.5c1.5-1.2,2.6-2.8,3.3-4.6l39.8,15.7 c-0.3,1.1-0.5,2.2-0.5,3.4C618.1,95.3,618.5,96.9,619.1,98.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M593.9,110.4l-20.7-31l1.1-0.7c0.2-0.1,0.4-0.3,0.5-0.4c1.3-1.1,2.3-2.4,2.9-4l0.5-1.2l42.1,16.7l-0.4,1.2 c-0.7,2.3-0.6,4.8,0.4,7l0.6,1.3L593.9,110.4z M576.7,80l18.1,27.2l22.7-9.5c-0.4-1.3-0.6-2.6-0.6-4c0-0.9,0.1-1.7,0.3-2.6 l-37.5-14.9C578.9,77.7,577.9,79,576.7,80z"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "619.6,99.6 618.7,97.2 628.3,93.2 629.2,95.6 "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "538.7,133.5 538.3,132.2 537.4,131.3 537.6,131.1 537.9,131 547.6,126.9 548.6,129.3 "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M701.3,153.6l-45-17.2l37.7-15.1C696.4,132.1,698.9,142.9,701.3,153.6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M738.7,110.8l-37.4,42.8l-7.3-32.2L738.7,110.8z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 685.2,
    y1: 116.1,
    x2: 676.1,
    y2: 110.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M764.8,161.5c-0.2-0.6-0.4-1.1-0.6-1.7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M758,144.7c-0.2-0.4-0.4-0.8-0.6-1.2s-0.4-0.8-0.6-1.3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M750.1,129.1c-0.6-1.1-1.2-2.1-1.8-3.1c-0.2-0.4-0.4-0.8-0.7-1.2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M746.6,123l-1-1.7c-0.3-0.5-0.6-1-1-1.5"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 676.1,
    y1: 110.5,
    x2: 669.6,
    y2: 119.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 664.9,
    y1: 211.4,
    x2: 664.7,
    y2: 211.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M694,194l-29,17.4c-1.2-5.6-2.9-11.1-5-16.4l-0.4-1.1c0-0.1,0-0.1-0.1-0.2c-2.5-6.3-5.7-12.2-9.5-17.9L694,194 z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M659.9,194.9c2.1,5.4,3.7,10.9,4.8,16.6"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "701.3,153.6 694,194 649.9,175.8 "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "730.2,169.4 694,194 701.3,153.6 "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "715.8,225 694,236.5 694,194 "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "694,194 694,236.5 667.2,236.5 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015349000195816896200000011164052180183237818_",
    gradientUnits: "userSpaceOnUse",
    x1: 731.4685,
    y1: 272.5543,
    x2: 732.0985,
    y2: 240.7943,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#3A8CAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#53AFDA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000015349000195816896200000011164052180183237818_)"
    },
    points: "748,212 715.8,225 730.2,169.4 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182516128196870644620000010744132925291499959_",
    gradientUnits: "userSpaceOnUse",
    x1: 731.9172,
    y1: 246.9443,
    x2: 732.1172,
    y2: 207.0243,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#327D9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#55AFD7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000182516128196870644620000010744132925291499959_)"
    },
    points: "748,212 748,233.2 715.8,225 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125600052396798419070000013503661162656621698_",
    gradientUnits: "userSpaceOnUse",
    x1: 748.0272,
    y1: 232.6843,
    x2: 775.2571,
    y2: 232.6843,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#327D9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#55AFD7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000125600052396798419070000013503661162656621698_)"
    },
    points: "775.3,261.5 748,233.2 748,212 "
  }), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "767,170.2 767.4,169.4 767.4,169.4 "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "765.8,164.6 748,212 730.2,169.4 "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M776.4,215.2L748,212l17.8-47.4c0.3,1,0.7,2,1,3c0.2,0.6,0.4,1.2,0.6,1.9c0,0.1,0.1,0.3,0.1,0.5 c0.2,0.5,0.3,1,0.5,1.6s0.4,1.4,0.6,2.1s0.4,1.3,0.6,1.9c0.4,1.4,0.8,2.8,1.2,4.3c0.1,0.5,0.3,1.1,0.4,1.6s0.2,1,0.4,1.5 c0.2,1,0.5,2,0.7,3.1l0.4,1.6c0.1,0.6,0.2,1.1,0.4,1.7c0.1,0.4,0.2,0.8,0.2,1.1c0.1,0.7,0.3,1.4,0.4,2s0.2,1.2,0.3,1.9 s0.2,1.2,0.3,1.8s0.2,1,0.2,1.5c0.2,0.9,0.3,1.8,0.4,2.7c0.1,0.7,0.2,1.3,0.3,2s0.2,1,0.2,1.5s0.2,1.3,0.3,1.9s0.2,1.5,0.3,2.3 c0.1,0.5,0.1,1,0.2,1.5s0.1,1.2,0.2,1.8s0.1,0.9,0.1,1.4C776.2,213.5,776.3,214.4,776.4,215.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M773.9,196.1c-0.1-0.6-0.2-1.2-0.3-1.8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M773.2,192.4c-0.1-0.7-0.3-1.4-0.4-2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041291721588688068500000000037373413303772078_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.9021,
    y1: 252.5427,
    x2: 761.0321,
    y2: 200.2827,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#327D9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#55AFD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041291721588688068500000000037373413303772078_)"
    },
    d: "M777.1,232.5c0,0.7,0,1.3,0,2v1.2l-0.1,2.8 c0,0.3,0,0.6,0,0.9l-0.1,1.8l-0.1,1.6c0,0.5,0,1-0.1,1.5c0,1-0.1,2-0.2,3c0,0.6-0.1,1.2-0.1,1.8c-0.1,1.3-0.2,2.6-0.3,3.9 c-0.1,0.7-0.1,1.3-0.2,2c0,0,0,0,0,0.1c-0.1,0.5-0.1,0.9-0.1,1.3c0,0.2,0,0.4-0.1,0.6c-0.1,0.6-0.2,1.3-0.2,2 c-0.1,0.9-0.2,1.7-0.3,2.5L748.1,212l28.4,3.2c0.2,2.8,0.4,5.6,0.6,8.6c0,0.8,0.1,1.5,0.1,2.3l0.1,2v0.3c0,0.5,0,1,0,1.5 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3v0.6C777.1,231.5,777.2,232,777.1,232.5z"
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M777.1,230.1c0-0.6,0-1.2,0-1.8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M777.1,231v-0.6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M777.1,232.5c0,1,0,2.1,0,3.1s0,1.9-0.1,2.8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M777.1,239.4c0,0.6,0,1.2-0.1,1.8l-0.1,1.6c0,0.5,0,1-0.1,1.5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M776.7,247.3c0,0.6-0.1,1.2-0.1,1.8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M776.2,252.9c-0.1,0.7-0.1,1.4-0.2,2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M775.9,257c-0.1,0.6-0.2,1.3-0.2,2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M666.5,115.2L623.9,136c-0.9-1.9-2.2-3.5-4-4.6c-0.7-0.5-1.5-0.8-2.3-1.1l8.1-26.2l0,0c1,0.3,2,0.5,3,0.5 c2.4,0,4.8-0.8,6.6-2.4c1.5-1.2,2.6-2.7,3.2-4.5l27.4,9.3C665.2,109.7,665.3,112.6,666.5,115.2L666.5,115.2z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M623.3,137.8l-0.5-1.2c-0.8-1.6-2-3-3.5-4c-0.6-0.4-1.3-0.8-2-1l-1.2-0.4l8.8-28.3h1h0.2 c0.9,0.3,1.8,0.4,2.7,0.4c2.1,0,4.2-0.7,5.8-2.1c1.3-1.1,2.3-2.4,2.8-4l0.4-1.2l29.8,10.1l-0.4,1.2c-0.8,2.3-0.6,4.9,0.4,7.1 l0.6,1.2L623.3,137.8z M619.2,129.5c0.5,0.2,1,0.5,1.4,0.8c1.6,1,2.9,2.4,3.9,4l40.4-19.8c-0.7-2.1-0.9-4.4-0.4-6.6l-25.2-8.6 c-0.8,1.5-1.8,2.8-3.1,3.9c-2.1,1.7-4.7,2.7-7.4,2.7c-0.7,0-1.5-0.1-2.2-0.2L619.2,129.5z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M694,121.4l-37.7,15.1l13.3-17.4c3.8,3.1,9.4,3.1,13.2-0.1c1-0.8,1.9-1.8,2.5-2.9L694,121.4z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M669.6,119.1l-13.3,17.4l-31.4,3.1c-0.1-1.3-0.5-2.5-1-3.6l42.6-20.8C667.2,116.7,668.3,118,669.6,119.1z"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 624.9,
    y1: 139.6,
    x2: 614.4,
    y2: 140.7
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M636,40l-57.3,26.3c-0.9-2-2.3-3.7-4.1-4.8c-3.4-2.2-7.7-2.2-11.2,0l-19.3-32l0.1-0.1c1.6-1.3,2.8-3.1,3.4-5.1 c0.4-1.1,0.6-2.2,0.5-3.4v-0.5c29.6-1.5,59.2,3,87,13.4c-0.1,0.5-0.1,1.1-0.1,1.6C635,37,635.4,38.5,636,40z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M578,68l-0.5-1.2c-0.8-1.7-2-3.2-3.6-4.2c-3-1.9-6.8-1.9-9.8,0l-1.1,0.7l-20.7-34.2l1.1-0.7 c1.4-1.2,2.5-2.7,3-4.5c0.3-1,0.5-2,0.5-3c0-0.1,0-0.3,0-0.4v-1.3l1.3-0.1c29.8-1.5,59.6,3.1,87.5,13.5l1,0.4l-0.2,1.1 c-0.3,1.8,0,3.7,0.7,5.4l0.5,1.2L578,68z M569,58.5c2.2,0,4.4,0.6,6.2,1.8c1.7,1.1,3,2.5,4,4.2l55.1-25.3c-0.4-1.2-0.6-2.5-0.6-3.8 c0-0.2,0-0.5,0-0.7c-27-9.9-55.6-14.4-84.3-13c-0.1,1-0.2,2-0.6,3c-0.6,1.9-1.7,3.6-3.1,5l18.1,30C565.5,58.9,567.2,58.5,569,58.5 L569,58.5z"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "645.5,36.8 635,35.2 635.3,32.6 645.9,34.2 "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "548,21.7 537.4,20.1 537.8,17.5 548.3,19.1 "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M488.4,150.5c-4,0-7.7,2.4-9.4,6l-67.2-54.1c1.4-1.3,2.4-2.9,3-4.7c0.4-1.1,0.6-2.2,0.5-3.4c0-0.1,0-0.2,0-0.2 l56.4-1.3c0.1,5.8,4.8,10.5,10.6,10.6c0.8,0,1.7-0.1,2.5-0.3L488.4,150.5z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M479.4,158.6l-69.6-56.1l1.1-1c1.2-1.1,2.1-2.5,2.6-4.1c0.3-1,0.5-2,0.5-3v-0.1l-0.1-1.4l59-1.4v1.3 c0.1,5.1,4.2,9.2,9.3,9.3c0.7,0,1.5-0.1,2.2-0.3l1.5-0.4l3.9,50.3h-1.4c-3.6,0-6.8,2.1-8.3,5.3L479.4,158.6z M413.8,102.3l64.9,52.3 c1.9-2.9,5-4.9,8.4-5.3l-3.4-44.7c-0.4,0.1-0.9,0.1-1.3,0.1c-6-0.1-11-4.6-11.8-10.6l-54,1.3c-0.1,1-0.3,1.9-0.6,2.8 C415.5,99.7,414.8,101.1,413.8,102.3z"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "488,165.5 478.2,157.6 479.8,155.5 489.5,163.4 "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "411.1,103.5 401.2,95.5 402.7,93.4 412.6,101.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030446411491620190320000004470735842380055700_",
    gradientUnits: "userSpaceOnUse",
    x1: 693.9871,
    y1: 232.3893,
    x2: 716.3571,
    y2: 232.3893,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#3A8CAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#53AFDA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000030446411491620190320000004470735842380055700_)"
    },
    points: "716.4,249.1 694,236.5 715.8,225  "
  }), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 665,
    y1: 254.9,
    x2: 664.9,
    y2: 254.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000207353413673640300000003211267324617854907_",
    gradientUnits: "userSpaceOnUse",
    x1: 679.4868,
    y1: 223.6542,
    x2: 679.3368,
    y2: 195.0542,
    gradientTransform: "matrix(1 0 0 -1 0 469.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#3A8CAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#53AFDA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000207353413673640300000003211267324617854907_)"
    },
    d: "M694,236.5l-29,18.5 c0.3-1.2,0.5-2.5,0.7-3.8c0.9-4.9,1.4-9.8,1.5-14.7H694z"
  }), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 667.2,
    y1: 236.5,
    x2: 664.9,
    y2: 254.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d3c008be1fc69766fdc3a60f89cf74af.svg";
export { ForwardRef as ReactComponent };